function importAll(context) {
  context.keys().forEach(context);
}

importAll(
  import.meta.webpackContext("./", {
    recursive: true,
    regExp: /\.(jsx?|tsx?)$/,
  }),
);
